import { render } from "./RecordedClasses.vue?vue&type=template&id=38a4caf0&ts=true"
import script from "./RecordedClasses.vue?vue&type=script&lang=ts"
export * from "./RecordedClasses.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__